module.exports = __webpack_public_path__ + "img/car.e5b22adf.svg";